import { Component, computed, OnDestroy, OnInit, Signal } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from '../shared/local-storage.service';
import { GroundfishDelivery } from '../shared/groundfish-delivery.model';
import { HMSDelivery } from '../shared/hms-delivery.model';
import { TrawlDelivery } from '../shared/trawl-delivery.model';

/**
 * List of completed deliveries.
 * Small component to display the deliveries and navigate to them.
 */
@Component({
    selector: 'app-delivery-list',
    templateUrl: './delivery-list.component.html',
    styleUrls: ['./delivery-list.component.css'],
    standalone: false
})
export class DeliveryListComponent {


  landings: Signal<(GroundfishDelivery | HMSDelivery | TrawlDelivery)[]>;
  editedLogbookId: Signal<string>;


  constructor(public dataSync: LocalStorageService, public router: Router) { 
    this.editedLogbookId = this.dataSync.current_user().trawlFishery ? computed(() => dataSync.edited_trawlLogbook().logbookId) :
    computed(() => dataSync.edited_logbook().GF.logbookId ?? dataSync.edited_logbook().HMS.logbookId);

    this.landings = computed(() => this.dataSync.current_user().trawlFishery ? dataSync.received_trawlLogbooks() : dataSync.received_logbooks());
  }


  onLandingClick(index: number) {
    this.router.navigate([this.landings()[index] instanceof GroundfishDelivery ? 'delivery_detail' :
      this.landings()[index] instanceof TrawlDelivery ? 'trawl_delivery' :
        'hms_delivery_detail', this.landings()[index].logbookId == this.editedLogbookId() ? 2 : 1, index], { queryParams: { previous: 'deliveries_list' } });
    if ((document.documentElement.scrollTop || document.body.scrollTop) > 0) window.scrollTo(0, 0);
  }

}
